import { Controller } from "@hotwired/stimulus"

// Formats the activation code input as the user types: VB-XXXX-XXXX.
// Always ensures the "VB" prefix; auto-inserts dashes.
export default class extends Controller {
  static targets = ["input"]

  format() {
    const el = this.inputTarget
    let v = el.value.toUpperCase().replace(/[^A-Z0-9]/g, "")
    if (!v.startsWith("VB")) v = "VB" + v.replace(/^V?B?/, "")
    v = v.slice(0, 10)

    let formatted = v.slice(0, 2)
    if (v.length > 2) formatted += "-" + v.slice(2, 6)
    if (v.length > 6) formatted += "-" + v.slice(6, 10)
    el.value = formatted
  }
}
